import { VglnSnijptFuncPlot, Nulpunt } from "../../../../content/wiskunde/1g_vgl/functies/drawings/plots";
import * as React from 'react';
export default {
  VglnSnijptFuncPlot,
  Nulpunt,
  React
};